
import { computed, defineComponent, onMounted, reactive, toRefs } from "vue";
import { MapLayerGroup } from "@/types";
import { useMap } from "@/services";

export default defineComponent({
  name: "MapGroupController",
  props: {
    group: {
      type: Object as () => MapLayerGroup,
      required: true,
    },
  },
  setup(props, { emit }) {
    onMounted(() => emit("update"));
    const update = (key: "isVisible" | "opacity", value: any) => {
      useMap().updateLayerGroup({ path: props.group.path, key, value });
    };
    return {
      ...toRefs(
        reactive({
          isOpen: false,
          layerGroups: computed(() => props.group.layerGroups),
          hasSubGroups: computed(
            () => !!props.group.layerGroups.length && !props.group.type
          ),
          isChecked: computed({
            get(): boolean {
              return props.group.isVisible;
            },
            set(val: boolean) {
              update("isVisible", val);
            },
          }),
        })
      ),
    };
  },
});
